import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hero_image']

  connect() {
    this.hero_imageTargets.forEach((hero_image) => {
      /* make random one visible */
      hero_image.classList.add('hidden');
    });
    this.hero_imageTargets[Math.floor(Math.random() * this.hero_imageTargets.length)].classList.remove('hidden');
  }
}
